var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { StringUtils } from '../../utils';
export var Kpi = function (props) {
    var _a;
    return (_jsxs("div", __assign({ className: "localina-kpi" }, { children: [_jsx("div", __assign({ className: "localina-kpi__label" }, { children: props.label })), _jsx("div", __assign({ className: "localina-kpi__value" }, { children: props.value })), props.hint && (_jsx("div", __assign({ className: StringUtils.combineStrings(['localina-kpi__hint', (_a = props.tone) !== null && _a !== void 0 ? _a : 'neutral']) }, { children: props.hint })))] })));
};
export var KpiGrid = function (props) {
    var _a;
    return (_jsx("div", __assign({ className: StringUtils.combineStrings(['localina-kpi-grid', "cols-".concat((_a = props.columns) !== null && _a !== void 0 ? _a : 4)]) }, { children: props.children })));
};
